"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CheckboxOn = _interopRequireDefault(require("../../icons/inputs/CheckboxOn"));

var _CheckboxOff = _interopRequireDefault(require("../../icons/inputs/CheckboxOff"));

var _withStyles = _interopRequireDefault(require("../../utils/withStyles"));

var _styles = _interopRequireDefault(require("./styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Checkbox = function Checkbox(_ref) {
  var classes = _ref.classes,
      id = _ref.id,
      checked = _ref.checked,
      value = _ref.value,
      label = _ref.label,
      onChange = _ref.onChange,
      disabled = _ref.disabled,
      props = _objectWithoutProperties(_ref, ["classes", "id", "checked", "value", "label", "onChange", "disabled"]);

  var CheckboxIcon = checked ? _CheckboxOn["default"] : _CheckboxOff["default"];
  return _react["default"].createElement("label", _extends({
    htmlFor: id,
    className: (0, _classnames["default"])(classes.root, disabled ? classes.disabled : null)
  }, props), _react["default"].createElement("input", {
    className: classes.inputEl,
    id: id,
    type: "checkbox",
    checked: checked,
    value: value,
    onChange: onChange,
    disabled: disabled
  }), _react["default"].createElement(CheckboxIcon, {
    className: classes.checkbox
  }), label);
};

Checkbox.propTypes = {
  /** Map of rule names and generated class names */
  classes: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,

  /** Checkbox id */
  id: _propTypes["default"].string,

  /** Bool flag indicating whether the Checkbox is currently checked or not */
  checked: _propTypes["default"].bool,

  /** Checkbox value */
  value: _propTypes["default"].string,

  /** Checkbox label */
  label: _propTypes["default"].string,

  /** Checkbox onChange callback */
  onChange: _propTypes["default"].func,

  /** Bool flag to enable/disable the Checkbox */
  disabled: _propTypes["default"].bool
};
Checkbox.defaultProps = {
  id: null,
  checked: false,
  value: '',
  label: '',
  onChange: function onChange() {},
  disabled: false
};

var _default = (0, _withStyles["default"])(_styles["default"])(Checkbox);

exports["default"] = _default;